import * as React from 'react';
import { connect } from 'react-redux';

import SignUpForm from '../../forms/signUpForm';
//import { doSignup } from "./actions";
import { StyleSheet, LayoutAnimation } from 'react-native';
import { Container, Header, H2, H3, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, List, ListItem, Thumbnail } from 'native-base';

import * as _ from 'lodash';
//import { NavigationActions, StackActions } from 'react-navigation';

import CalCalDataApi from '../../api/CalCalDataApi';
import Alert from '../../components/alert';
import doDemo from './doDemo';

import jwt_decode from 'jwt-decode';

//import XDate from 'xdate';

import { formValueSelector, change, SubmissionError } from 'redux-form';

// -- What if we're offline??

class DemoSelect extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			demos: null,
			showingOne: null
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		this.getDemos();
	}

	getDemos() {
		CalCalDataApi.dataLoadWithHeads('demos', '', (res) => {
			if (res) {
				this.setState({ demos: res });
			} else {
				this.setState({ isError: true });
			}
		});
	}

	expand(i) {
		LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
		this.setState({ showingOne: this.state.showingOne == i ? null : i });
	}

	renderHeader() {
		return (
			<Header>
				<Left>
					<Button transparent onPress={() => this.props.navigation.goBack()}>
						<Icon name="ios-arrow-back" />
					</Button>
				</Left>
				<Body>
					<Title>Select a demo</Title>
				</Body>
				<Right />
			</Header>
		);
	}

	render() {
		const head = this.renderHeader();
		if (!this.state.demos)
			return (
				<Container style={styles.container}>
					{head}
					<Spinner />
					<Text style={styles.centretxt}>Connecting to CalCal...</Text>
				</Container>
			);
		const { showingOne } = this.state;

		return (
			<Container style={styles.container}>
				{head}
				<Content keyboardShouldPersistTaps={'handled'} style={{ padding: 10 }}>
					<List>
						{this.state.demos.map((demo, i) => (
							<ListItem thumbnail key={i} onPress={() => this.expand(i)} style={{ flexDirection: showingOne == i ? 'column' : 'row' }}>
								<Left>
									<Thumbnail square source={{ uri: demo.logoPath }} large={showingOne == i} />
								</Left>
								<Body>
									<Text style={{ fontSize: showingOne == i ? 24 : 14 }}>{demo.title}</Text>
									<Text note numberOfLines={showingOne == i ? null : 1}>
										{demo.description}
									</Text>
								</Body>
								{showingOne != i && (
									<Right>
										<Button transparent onPress={() => this.expand(i)}>
											<Text>View</Text>
										</Button>
									</Right>
								)}
								{showingOne == i && (
									<Button center bordered full onPress={() => doDemo(demo, this.props.dispatch)}>
										<Text>Start ></Text>
									</Button>
								)}
							</ListItem>
						))}
					</List>
				</Content>
			</Container>
		);
	}
}

const styles = StyleSheet.create({
	container: {
		backgroundColor: '#FBFAFA',
		padding: 0
	},
	centretxt: {
		alignSelf: 'center'
	}
});

const mapStateToProps = (state) => ({
	user: state.loginReducer.user,
	busDetails: state.globalReducer.busDetails
	//online: state.network.isConnected
});

export default connect(mapStateToProps)(DemoSelect);
